import PropTypes from 'prop-types'
import { BlockLayout, CardTitle } from '@usb-ui-tools/react-billpay-layout'
import { useMultilingualService } from '../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../utils/browserutils'

// import "./find-bill-header.scss"
function generateShell(payeeList, HEADER) {
  if (isOLBOrIpadApp()) {
    return (
      <BlockLayout
        actAs="shell"
        mobileTopMargin="0"
        compact={!(payeeList?.length > 0)}
        gapOnBottom="16"
      >
        <div
          id="findbill-addtional-text"
          className="usb-tg-body-small usb-c-gray-80"
        >
          {payeeList?.length > 0
            ? HEADER?.FIND_BILL_HEADER_SUBTEXT
            : HEADER?.NO_BILLS_FOUND_SUB_TEXT}
        </div>
      </BlockLayout>
    )
  }
  return (
    !payeeList?.length > 0 && (
      <BlockLayout
        actAs="shell"
        mobileTopMargin="0"
        compact={!(payeeList?.length > 0)}
      >
        <div
          id="findbill-addtional-text"
          className="usb-tg-body-small usb-c-gray-80"
        >
          {HEADER?.NO_BILLS_FOUND_SUB_TEXT}
        </div>
      </BlockLayout>
    )
  )
}
const FindbillsHeader = ({
  isFieldsValidationError,
  pageErrorMsg,
  payeeList
}) => {
  const { HEADER } = useMultilingualService('findbills')

  return (
    <>
      <CardTitle
        {...{
          notificationArray: [
            {
              type: 'error',
              message: pageErrorMsg || HEADER?.PAGEERROR,
              show: isFieldsValidationError
            }
          ],
          pageTitleText:
            payeeList?.length > 0
              ? HEADER?.FIND_BILL_HEADER
              : HEADER?.NO_BILLS_FOUND_HEADER,
          isOLBOrIpadApp,
          showAvatar: false,
          id: 'find-bill-header',
          cardTitleTextSameAsPageTitleText: true,
          nickName:
            !isOLBOrIpadApp() && payeeList?.length > 0
              ? HEADER?.FIND_BILL_HEADER_SUBTEXT
              : '',
          compact: !(payeeList?.length > 0),
          gapThruMarginTop: true
        }}
      />
      {generateShell(payeeList, HEADER)}
    </>
  )
}

FindbillsHeader.propTypes = {
  isFieldsValidationError: PropTypes.bool.isRequired,
  pageErrorMsg: PropTypes.string.isRequired,
  payeeList: PropTypes.arrayOf(PropTypes.any).isRequired
}
export default FindbillsHeader
